import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

import * as _ from 'underscore';

// Service
import { ClientTypeListService } from '../../service/client-type-list/client-type-list.service';
import { LayoutProposta } from '../../../models/layout-proposta';

@Component({
	selector: 'app-client-type-list',
	templateUrl: './client-type-list.component.html',
	providers: [
		ClientTypeListService,
		HttpModule
	]
})

export class ClientTypeListComponent implements OnInit {
	private token;
	public clienttypes: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Nome";
	public sort: string = "asc";
	public permissoes: any[] = [];
	public layoutProposta: LayoutProposta;
	currentPage: number = 0;
	clientType: FormGroup;

	constructor(fb: FormBuilder, private clienttypeListService: ClientTypeListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.layoutProposta = new LayoutProposta();
		this.clientType = fb.group({
			'Nome': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.searchClientType(this.clientType.value, 0, false);
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchClientType(this.clientType.value, this.currentPage, false);
	}

	searchClientType(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.clienttypeListService.searchClientType(this.token, value.Nome, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.clienttypes = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchClientType(this.clientType.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/client-type/component/client-type-list/client-type-list.component.ts